<div class="documents-dialog-wrapper">
  <div class="dialog-card">
    <div class="dialog-header">
      <img src="assets/booking-engine/icons/folder-icon.png" alt="Folder" class="folder-icon">
      <h2 class="dialog-title">Documents</h2>
    </div>
    
    <div class="documents-list">
      <div class="document-item" *ngFor="let doc of documents; let last = last" [class.last-item]="last">
        <span class="document-name" [innerHTML]="formatDocumentName(doc.name)"></span>
        <button 
          *ngIf="doc.hasDownload" 
          class="download-button" 
          type="button"
          (click)="onDownload(doc.name)"
          [attr.aria-label]="'Download ' + doc.name">
          <img src="assets/booking-engine/icons/download-down-arrow.png" alt="Download" class="download-icon">
        </button>
        <mat-icon 
          *ngIf="!doc.hasDownload && shouldShowInfoIcon(doc.name)"
          class="info-icon"
          [matTooltip]="'Dates are not set for some activities, Please fill the dates'"
          matTooltipPosition="left"
          [attr.aria-label]="'Info: Dates are not set for some activities'">
          info
        </mat-icon>
      </div>
    </div>
  </div>
</div>

